import { P1, Rating } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations';
import React from 'react';

import styles from './OwnBrandReview.module.scss';

export type ReviewProps = {
  reviewNumber: number;
};

export const OwnBrandReview = (props: ReviewProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.review}>
      <div className={styles.reviewName}>
        {t(`ob.userreviews.review_${props.reviewNumber}.name`)}
      </div>
      <div className={styles.reviewParagraph}>
        <span className={styles.reviewRating}>
          <Rating rating={5} ratingLabel={''} />
        </span>
        <P1 className={styles.reviewText}>
          {t(`ob.userreviews.review_${props.reviewNumber}.content`)}
        </P1>
      </div>
    </div>
  );
};
